module.exports = __webpack_public_path__ + "img/banner5.d2dd475b.png";